import type { Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ModalService } from 'components/organisms/modal';
import { PERSONAL_DATA_PROTECTION_POLICY } from 'src/services/personal-data-protection/interfaces/personal-data-protection-policy.interface';
import {
    DEFAULT_CONSENT_TYPE,
    REQUEST_PERSONAL_DATA_PROTECTION_CONSENT,
} from 'src/services/personal-data-protection/tokens';

import { UC_SERVICE_TO_CONSENT_CAT, UC_SERVICES } from '../user-centrics/entities/const';
import { userCentricsNoticePopupFactory } from '../user-centrics/user-centrics-notice-popup.factory';
import { UserCentricsPolicy } from '../user-centrics/user-centrics-policy.service';
import { UserCentricsStateConvertorService } from '../user-centrics/user-centrics-state-convertor.service';
import { UserCentricsService } from '../user-centrics/user-centrics.service';

export function provideConsentManagementPlatform(): Provider[] {
    return [
        UserCentricsService,
        UserCentricsStateConvertorService,
        UserCentricsPolicy,
        {
            provide: PERSONAL_DATA_PROTECTION_POLICY,
            useFactory: (userCentricsPolicy: UserCentricsPolicy) => {
                return userCentricsPolicy;
            },
            deps: [UserCentricsPolicy],
        },
        {
            provide: DEFAULT_CONSENT_TYPE,
            useFactory: () => {
                return UC_SERVICE_TO_CONSENT_CAT[UC_SERVICES.Advertising];
            },
            deps: [],
        },
        {
            provide: REQUEST_PERSONAL_DATA_PROTECTION_CONSENT,
            useFactory: (
                translateService: TranslateService,
                modalService: ModalService,
                userCentricsService: UserCentricsService
            ) => {
                return userCentricsNoticePopupFactory(translateService, modalService, userCentricsService);
            },
            deps: [TranslateService, ModalService, UserCentricsService],
        },
    ];
}
